import { Component, ViewChild } from '@angular/core';

import { CommonService } from '../../../../../shared/services/common.service';
import { Router } from '@angular/router';
import { ApiService } from '../../../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { HttpClient } from '@angular/common/http';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import saveAs from 'file-saver';
import * as XLSX from 'xlsx';
import { MatTableDataSource } from '@angular/material/table';
import { ONSPOTableModel } from '../../../../../shared/models/IAOnspot';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, switchMap } from 'rxjs';
@Component({
  selector: 'app-viewallonspotregistration',
  templateUrl: './viewallonspotregistration.component.html',
  styleUrl: './viewallonspotregistration.component.css'
})
export class ViewallonspotregistrationComponent {

  dataSource!: MatTableDataSource<ONSPOTableModel>
  //displayedColumns: string[] = ['Sr.No', 'registrationId', 'onSpotUserId', 'enterpriseName', 'email', 'mobileNumber', 'gstNumber','udyamNumber','Actions','licenseUnderFactoriesAct',
  //  'registrationUnderShopsAndEstbmtAct', 'tradeLicenseCertificate']

  displayedColumns: string[] = ['Sr.No', 'registrationId', 'onSpotUserId', 'enterpriseName', 'email', 'mobileNumber', 'gstNumber', 'udyamNumber', 'Actions']

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';
  reportData: any[] = [];
  allrecord: any[] = [];
  shortEventName: string = '';
  udyamNumber: string = '';
  Formloaded: boolean = false;
  IAUserId: any;
  uniqueEventId: any;
  items: any[] = [];
  registrationId: any;

  pageSizeOptions: number[] = [10, 20, 50, 100];
  page = 1;
  pageSize = 10;
  length: number = 0;  //DtoPagination =
  total_count: any;
  isTotalCount: boolean = false;
  isTotalCountStatusMessageHidden = false;
  onspotlimit: number = 0;
  
  
  //  {
  //    "PageNumber": 1,
  //    "PageSize": 20,
  //    "SortColumn": "",
  //    "SortDirection": "",
  //    "SearchTerm": ""
  //  }

  DtoPagination =
    {
      "UserId": sessionStorage.getItem("industryAssociationUserId"),
      "EventId": sessionStorage.getItem("uniqueEventId"),
      "PageNumber": 1,
      "PageSize": 10,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol":""
    }
   


  constructor(private router: Router,
    private toastr: ToastrService,
    private http: HttpClient,
    private common: CommonService,
    private apiService: ApiService,
    private toastrService: ToastrService) { }

  onspotform = new FormGroup({
   
    searchControl: new FormControl('', [
      Validators.pattern(this.common.searchFilter)
    ])
  })

  //ngOnInit(): void {
  //  sessionStorage.getItem('onSpotUserId')
  //  //sessionStorage.getItem('uniqueeventid')
  //  this.DtoPagination.PageSize = 20;
  //  if (!this.Formloaded) {
  //    this.loadAllrecord();
  //    this.Formloaded = true;
  //  }
  // // this.IAUserId = sessionStorage.getItem('industryAssociationUserId');
  // // this.uniqueEventId = sessionStorage.getItem('uniqueEventId')
  //  this.loadReport(this.IAUserId);

  //}

  ngOnInit(): void {
    sessionStorage.getItem('onSpotUserId')

    //sessionStorage.getItem('uniqueEventId')
    sessionStorage.getItem('uniqueEventId')
    sessionStorage.getItem('eventId')

    //uniqueEventId
    
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchCol = this.common.searchText;
  }


  ngAfterViewInit() {
    this.loadReport(this.IAUserId);
  }

  //before-no onspot limit
  //loadReport(userID: any) {
  //  this.sort.sortChange.subscribe(() => this.pagination.pageIndex = 0);
  //  merge(this.sort.sortChange, this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
  //    this.pagination.page)
  //    .pipe(filter(searchTerm => searchTerm != null),
  //      switchMap((searchTerm) => {
  //        if (searchTerm) {
  //          this.pagination.pageIndex = 0;
  //        }
  //        this.DtoPagination.SortColumn = this.sort.active;
  //        this.DtoPagination.SortDirection = this.sort.direction;
  //        this.DtoPagination.SearchCol = this.common.searchText;
  //        return this.apiService.getRequest(API_ENDPOINTS.IA.GETONSPOTREGISTRATIONRECORD, this.DtoPagination)
  //          .pipe(catchError(() => of(null)));

  //      }),
  //      map(resp => {
  //        if (resp.status) {
  //          this.length = resp['totalRecords'];
  //          //this.total_count = resp['total_count'];
  //          this.total_count = resp.data.total_count == 1 ? true : false;
  //          this.isTotalCountStatusMessageHidden =this.total_count;



  //          //alert("this.total_count : " +this.total_count);

  //          console.log("datasource:", resp);
  //          return resp.data.map((item: any) => ({
  //            ...item,
  //            mobileNumber: item.udyamNumber ? item.mobileNo : item.mobileNumber
  //          }));


  //        }

  //        return resp.data;

  //      })
  //    ).subscribe(data => {
  //      this.dataSource = new MatTableDataSource(data);



  //      //this.dataSource = data;
  //      this.adjustPaginator();




  //    });
  //}


  //after-on spot limit
  loadReport(userID: any) {
    this.sort.sortChange.subscribe(() => this.pagination.pageIndex = 0);
    merge(this.sort.sortChange, this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
      this.pagination.page)
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap((searchTerm) => {
          if (searchTerm) {
            this.pagination.pageIndex = 0;
          }
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.common.searchText;

          this.DtoPagination.PageNumber = this.pagination.pageIndex + 1; // Convert 0-based to 1-based index
          this.DtoPagination.PageSize = this.pageSize;

          //// **Update URL with pagination parameters**
          //this.router.navigate([], {
          //  queryParams: this.DtoPagination,
          //  queryParamsHandling: 'merge', // Keep existing query params
          //});


          return this.apiService.getRequest(API_ENDPOINTS.IA.GETONSPOTREGISTRATIONRECORD, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp?.status) {
            this.length = resp['totalRecords'];
            this.onspotlimit = resp.onSpotLimit;
            // If total_count is 1, disable the button
            //this.total_count = resp.data.total_count == 1 ? true : false;
            if (resp.total_count == 1) {

              this.isTotalCount = true;
            }
            
            
            
            this.isTotalCountStatusMessageHidden = this.total_count;

            //console.log("datasource:", resp);

            this.shortEventName = resp.data[0]['eventId'];
            sessionStorage.setItem("shortEventName", this.shortEventName);
            this.udyamNumber = resp.data[0]['udyamNumber'];
            sessionStorage.setItem("udyamNumber", this.udyamNumber);
            return resp.data.map((item: any) => ({
              ...item,
              mobileNumber: item.udyamNumber ? item.mobileNo : item.mobileNumber
            }));
          }
          return resp?.data || [];
        })
      ).subscribe(data => {
        this.dataSource = new MatTableDataSource(data);
        this.adjustPaginator();
      });
  }




  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  //loadReport(userID: any): void {
  //  this.apiService.getRequest(API_ENDPOINTS.IA.GETONSPOTREGISTRATIONRECORD, this.DtoPagination).subscribe(
  //    (data) => {
  //      this.length = data['totalRecords']
  //      this.reportData = data.data;


  //    },
  //    (error: any) => {
  //      console.error('Error fetching report data:', error);
  //    }
  //  );
  //}

  loadAllrecord() {
    const DtonullPagination = {
      EventId: sessionStorage.getItem("uniqueEventId"),
      PageNumber: 1,    // or undefined
      PageSize: 9999999,      // or undefined
      SortColumn: "",  // example sort column
      SortDirection: "", // example sort direction
      SearchTerm: ""   // optional search term
    };
    this.apiService
      .getRequest(API_ENDPOINTS.IA.GETONSPOTREGISTRATIONRECORD, DtonullPagination)
      .subscribe({
        next: (data: any) => {
          this.length = data.totalRecords;
          this.allrecord = data.data;

          const registrationId = this.allrecord?.[0]?.registrationId;
          if (registrationId) {
            sessionStorage.setItem('registrationId', registrationId);
          }
        },
        error: (error: any) => {
          console.error('Error fetching report data:', error);
        }
      });
    //this.apiService.getRequest(API_ENDPOINTS.IA.GETONSPOTREGISTRATIONRECORD, DtonullPagination).subscribe(
    //  (data) => {
    //    this.length = data['totalRecords']
        
    //    this.allrecord = data.data;
    //    //console.log(this.allrecord)
    //    const registrationId = this.allrecord[0]?.registrationId;
       
    //    sessionStorage.setItem("registrationId", registrationId);
    //    //console.log("registration id:",registrationId)
    //    //sessionStorage.getItem("registrationId", registrationId);

    //  },
    //  (error: any) => {
    //    console.error('Error fetching report data:', error);
    //  }
    //);

  }

  onEdit(onSpotUserId: string): void {
   
    //edit on spot registration
    sessionStorage.setItem("onspotuserid", onSpotUserId);
    //console.log("onspotuserid :", onSpotUserId);
    this.router.navigate(['/editonspot', onSpotUserId], { queryParams: { mode: 'edit' } });

  }

  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }
  




  
  //DownloadTicket(uniqueEventId: string, onSpotUserId: string) {

  //  const eventId = sessionStorage.getItem("EventId") ?? ""; // Ensuring it's a string

  //  if (!eventId) {
  //    //console.warn("Event ID is null. Cannot proceed.");
  //    return;
  //  }

  //  sessionStorage.setItem("EventId", eventId);
   
  //  sessionStorage.setItem("uniqueEventId", uniqueEventId);
  //  //console.log("uniqueEventId is :",uniqueEventId)
  //  //uniqueEventId
  //  sessionStorage.setItem("onSpotUserId", onSpotUserId);

  //  //sessionStorage.setItem("RegistrationId", registrationId); // Ensure case consistency
  //  //console.log("Stored -> EventId:", eventId, "RegistrationId:", registrationId);
  //  this.router.navigate(['/iadownloadticket']);
  //}

  DownloadTicket(uniqueEventId: string, onSpotUserId: string, udyamNumber: string, shortEventName: string)
  {
    sessionStorage.setItem("udyamNumber", udyamNumber);
    sessionStorage.setItem("shortEventName", shortEventName);
    sessionStorage.setItem("uniqueEventId", uniqueEventId);
    sessionStorage.setItem("onSpotUserId", onSpotUserId);

    //console.log("Downloading ticket for:");
    //console.log("Unique Event ID:", uniqueEventId);
    //console.log("OnSpot User ID:", onSpotUserId);
    //console.log("Udyam Number:", udyamNumber);
    //console.log("Short Event Name:", shortEventName);
    this.router.navigate(['/iadownloadticket']);

    // Your download logic here
  }



  isToday(dateString: string): boolean {
    const eventDate = new Date(dateString);
    const today = new Date();
    return (
      eventDate.getFullYear() === today.getFullYear() &&
      eventDate.getMonth() === today.getMonth() &&
      eventDate.getDate() === today.getDate()
    );
  }
  
  CreateNewRegistration(eventid: string): void {
    var eventid = sessionStorage.getItem("uniqueEventId")!;
    this.router.navigate(['/onspotregistration', eventid], { queryParams: { mode: 'new' } });
  }


  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;

  onPageChange(e: PageEvent) {

    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.loadReport(this.IAUserId);
  }

  onSearchChange(event: Event): void {
    this.onspotform.get('searchControl')?.markAsTouched();
    const searchValue = (event.target as HTMLInputElement).value;
    if (this.onspotform.get('searchControl')?.valid) {
      this.DtoPagination.SearchTerm = searchValue;
      this.loadReport(this.IAUserId); // Fetch filtered data
    }
  }


  onSearchClick(searchValue: string): void {
    const searchControl = this.onspotform.get('searchControl');
    searchControl?.markAsTouched(); // Mark the control as touched for validation feedback

    if (searchControl?.valid && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.loadReport(this.IAUserId); // Fetch filtered data
      //console.log('Search triggered with value:', searchValue);
    } else if (searchValue.trim() === '') {
      console.error('Search term is empty');
    } else {
      console.error('Invalid search term');
    }
  }
  resetPage() {
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = this.common.searchText;
    this.loadReport(this.IAUserId);
  }


  exportToExcel(): void {
    const fileName = 'On_Spot_User_List.xlsx';

    

   const DtoPagination =
    {
      "UserId": sessionStorage.getItem("industryAssociationUserId"),
      "EventId": sessionStorage.getItem("uniqueEventId"),
      "PageNumber": 1,
      "PageSize": 9999999,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": ""
    }

    this.apiService.getRequest(API_ENDPOINTS.IA.GETONSPOTREGISTRATIONRECORD, DtoPagination).subscribe(
      result => {
        if (result.status) {
          this.allrecord = result.data;

          if (!this.allrecord || this.allrecord.length === 0) {
            this.toastr.error('No data available to export.');
            return;
          }

          const excelData = this.allrecord.map((item, index) => ({
            'Sr.No': item.RowNum,
            'enterpriseName': item.enterpriseName,
            'email': item.email,
            'gstNumber': item.gstNumber,
            'udyamNumber': item.udyamNumber

          }));

          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

          const columnWidths = [
            { wch: 10 }, // Sr.No            
            { wch: 30 }, // Event Focus Sector Type
            { wch: 30 }, // Event Focus Sector Name
          ];
          worksheet['!cols'] = columnWidths;

          const workbook: XLSX.WorkBook = {
            Sheets: { 'On Spot User List': worksheet },
            SheetNames: ['On Spot User List'],
          };

          const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
          });

          const data: Blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
          });

          saveAs(data, fileName);
          this.toastr.success('Excel exported successfully!');
        }
      }
    );
  }



  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }
}
